module.exports = __webpack_public_path__ + "img/steve-bw.3c08ff94.png";